import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function FAQAccordion({ items, testIdPrefix = "faq" }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="divide-y divide-[#E5E0D8]" data-testid={`${testIdPrefix}-list`}>
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="py-2">
            <button
              data-testid={`${testIdPrefix}-toggle-${i}`}
              onClick={() => setOpen(isOpen ? null : i)}
              className="w-full flex items-center justify-between gap-6 py-6 text-left group"
              aria-expanded={isOpen}
            >
              <span className="font-serif text-xl md:text-2xl text-[#1A1A1A] group-hover:text-[#C9A96E] transition-colors">
                {it.question}
              </span>
              <span className="shrink-0 w-9 h-9 flex items-center justify-center border border-[#C9A96E]/40 text-[#C9A96E]">
                {isOpen ? <Minus size={16} /> : <Plus size={16} />}
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="overflow-hidden"
                >
                  <div
                    data-testid={`${testIdPrefix}-answer-${i}`}
                    className="pb-6 pr-12 text-[#6B7280] leading-relaxed text-base"
                  >
                    {it.answer}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
